// ============================================
// COMPONENT: LoadingSpinner
// ============================================
// Archivo: src/components/common/LoadingSpinner.jsx

import React from 'react';

const LoadingSpinner = ({ text = 'Procesando...' }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center shadow-2xl">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600"></div>
        <p className="mt-4 text-gray-700 font-medium">{text}</p>
      </div>
    </div>
  );
};

export { LoadingSpinner };
export default LoadingSpinner;
